import { Inject, Injectable } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

import { IBetslipMessages } from '../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { BetslipType } from '../../../../core/betslip-type';
import { BetslipError } from '../../errors/betslip-error';
import { ExtendedBetslipNotification, IBetslipNotification, SimpleBetslipNotification } from '../../errors/betslip-notification';
import { OddsChanged } from '../../errors/result/odds-changed';

@Injectable()
export default class BetslipErrorsUtilsService {
    private messages: IBetslipMessages;
    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        this.messages = messageProvider.getMessages();
    }

    getToastNotification(errors: BetslipError[], currentSelectedType: Nullable<BetslipType>): IBetslipNotification {
        const isInEditBet = currentSelectedType === BetslipType.EditBet;

        return isInEditBet ? this.getEditBetToastMessage(errors) : new SimpleBetslipNotification(this.messages.common.GlobalToastMessage);
    }

    private getEditBetToastMessage(errors: BetslipError[]): IBetslipNotification {
        if (errors.find((error) => error instanceof OddsChanged)) {
            return new ExtendedBetslipNotification(this.messages.editBet.cashOutFailedTitle, this.messages.editBet.cashOutFailedMessage);
        }

        return new SimpleBetslipNotification(this.messages.editBet.toastMessage);
    }
}
